import { SwitchFieldValue } from "../../types/fieldTypes";
import { SwitchFieldProps } from "./SwitchField";
import React, { useEffect } from "react";

export const useSwitchField = (props: SwitchFieldProps) => {
  const [localValue, setLocalValue] = React.useState<SwitchFieldValue>(
    props.value
  );

  useEffect(() => {
    setLocalValue(props.value);
  }, [props.value]);

  useEffect(() => {
    props.onSubmit && props.onSubmit(localValue);
  }, [localValue]);

  return { localValue, setLocalValue };
};
